/*
  Compares arrays of primitives for equality without sorting
 */
export const areArraysEqual = (
  firstArray: string[],
  secondArray: string[],
): boolean => {
  return (
    firstArray.length === secondArray.length &&
    firstArray.every((item, index) => item === secondArray[index])
  );
};
